import { Show } from '@/components/show'
import { TableHead, TableHeader, TableRow } from '@/components/ui/table'

interface CoursesEquivalencesTableHeaderProps {
  showStatusColumn?: boolean
}

export const CoursesEquivalencesTableHeader = ({
  showStatusColumn = true
}: CoursesEquivalencesTableHeaderProps) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="font-semibold">
          Disciplina a ser aproveitada
        </TableHead>
        <TableHead className="font-semibold w-36">Carga Horária</TableHead>
        <TableHead className="w-2"></TableHead>
        <TableHead className="font-semibold">
          Disciplina cursada pelo aluno
        </TableHead>
        <TableHead className="font-semibold w-26">CH</TableHead>
        <TableHead className="font-semibold w-26">Nota</TableHead>
        <TableHead className="font-semibold w-36">Período</TableHead>
        <Show when={showStatusColumn}>
          <TableHead className="font-semibold w-56">Status</TableHead>
        </Show>
        <TableHead className="w-0 p-0"></TableHead>
      </TableRow>
    </TableHeader>
  )
}
